import React from 'react';
import cn from 'classnames';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';

import * as Styles from '../Icon.module.scss';

const TESTID = 'icon-exclamation';
export const ExclamationIcon = ({ size = 'medium', fill = 'dsgGreen', className }: IconProps) => {
    const iconSize = IconSizes[size];
    const fillStyle = cn(Styles[fill], Styles.fill, className);

    return (
        <svg
            width={iconSize}
            height={iconSize}
            className={fillStyle}
            viewBox="0 0 40 40"
            xmlns="http://www.w3.org/2000/svg"
            data-testid={TESTID}
        >
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g className={fillStyle}>
                    <path d="M20,0 C31.045695,0 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 C8.954305,40 0,31.045695 0,20 C0,8.954305 8.954305,0 20,0 Z M20,27 C18.3431458,27 17,28.3431458 17,30 C17,31.6568542 18.3431458,33 20,33 C21.6568542,33 23,31.6568542 23,30 C23,28.3431458 21.6568542,27 20,27 Z M20,29 C20.5522847,29 21,29.4477153 21,30 C21,30.5522847 20.5522847,31 20,31 C19.4477153,31 19,30.5522847 19,30 C19,29.4477153 19.4477153,29 20,29 Z M21,7 L19,7 C17.8954305,7 17,7.8954305 17,9 L17,23 C17,24.1045695 17.8954305,25 19,25 L21,25 C22.1045695,25 23,24.1045695 23,23 L23,9 C23,7.8954305 22.1045695,7 21,7 Z M21,9 L21,23 L19,23 L19,9 L21,9 Z"></path>
                </g>
            </g>
        </svg>
    );
};

ExclamationIcon.TEST_ID = TESTID;
